import { writable } from "svelte/store";

export const error = writable(null);

export const showMessage = writable(false);
export const messageObject = writable({});

export const isAuthenticated = writable(false);
export const isAdmin = writable(false);

export const isMobile = writable(null);
export const showSidebar = writable(true);

export const user = writable(null);
export const client = writable(null);

export const activePage = writable(null);
export const isLoading = writable(null);

export const searchInput = writable("");

export const cart = writable([]);

export const searchArray = writable([]);

export const productModalSku = writable(null);
export const showProductModal = writable(null);

export const locale = writable(null);

export const categories = writable([]);
